import Chip from "@mui/material/Chip";
import { alpha } from "@mui/material/styles";

import { VISIT_STATUSES } from "../../../../utils/constants";

const STATUS_STYLES = {
  [VISIT_STATUSES.COMPLETED]: { color: "success", text: "Completed" },
  [VISIT_STATUSES.INCOMPLETE]: { color: "warning", text: "Incomplete" },
  [VISIT_STATUSES.SKIPPED]: { color: "default", text: "Skipped" },
  [VISIT_STATUSES.NOT_OPENED]: { color: "info", text: "Not opened" },
};

// "In-clinic: Completed" style pill; renders nothing for statuses the backend could not resolve
const VisitStatusChip = ({ label, status }) => {
  const style = STATUS_STYLES[status];
  if (!style) return null;

  return (
    <Chip
      size="small"
      color={style.color}
      variant={style.color === "default" ? "outlined" : "filled"}
      label={`${label}: ${style.text}`}
      sx={{
        fontWeight: 600,
        borderRadius: 1.5,
        ...(style.color !== "default" && {
          bgcolor: (theme) => alpha(theme.palette[style.color].main, 0.12),
          color: (theme) => theme.palette[style.color].dark,
        }),
      }}
    />
  );
};

export default VisitStatusChip;
